import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

export default function(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
  options
) {
  return function(Component) {
    return withRouter(
      connect(mapStateToProps, mapDispatchToProps, mergeProps, options)(
        Component
      )
    );
  };
}



// WEBPACK FOOTER //
// ./src/app/api/redux-util/connect-enhancer.js